import React from 'react';
import { useLocation } from 'react-router-dom';

import Loader from '../../../../components/Loader/Loader';
import PreviewGenerationFallback from './PreviewGenerationFallback';
import { isConversationPreviewPath } from './PreviewGenerationFallback';

function ConversationRouteFallback() {
    const { pathname } = useLocation();
    return isConversationPreviewPath(pathname)
        ? <PreviewGenerationFallback />
        : <Loader />;
}

export default ConversationRouteFallback;
